export default {
  name: "canceled-order-card",
  components: {},
  props: ["iso", "subRoute"],
  data() {
    return {
      dialog: false
    };
  },
  computed: {},
  mounted() {},
  methods: {
    handleDialog() {
      this.$emit("confirmCancelOrder", false);
      this.dialog = true;
    }
  }
};
